module.exports = __webpack_public_path__ + "img/forget-password.svg";